<template>
  <div>
    <div class="row">
      <div class="col-md-8 col-12">
        <p class="card-title mt-0 mb-0">{{ grant.Organization }}</p>
        <p v-if="grant.Requires_501C3" class="card-text small mb-2">
          <b>501(c)(3) Required</b>
        </p>
      </div>
      <div class="col-md-4 col-12 text-right">
        <p class="card-text mb-0">Award Amount: {{ grant.Award_Amount }}</p>
        <p class="card-text text-muted small">
          Added {{ $displayDate(grant.Date_Added) }}
        </p>
      </div>
    </div>
    <div class="row">
      <p
        class="card-text text-justify ml-3 mr-3"
        style="white-space: pre-wrap;"
      >
        {{ grant.Description }}
      </p>
    </div>
    <div class="row mt-2">
      <div class="col-lg-5 col-12">
        <p class="card-text">
          <b>Grades:</b>
          {{ $createTeachingGradeDescriptionList(grant.Teaching_Grade) }}
        </p>
      </div>
      <div class="col-lg-2 col-12">
        <p class="card-text">
          <b>Level:</b>
          {{ $createAwardLevelDescriptionList(grant.Award_Level) }}
        </p>
      </div>
      <div class="col-lg-5 col-12">
        <button
          v-bind:id="'subjectsPopover' + grant.Grant_Id"
          class="btn text-left pt-0 pl-0"
          data-toggle="popover"
          data-trigger="focus"
          v-on:click="$focusElement('subjectsPopover' + grant.Grant_Id)"
          data-placement="right"
          v-bind:data-content="
            $createTeachingSubjectDescriptionList(grant.Teaching_Subject)
          "
        >
          <p class="card-text shorten-text">
            <b>Category:</b>
            {{ $createTeachingSubjectDescriptionList(grant.Teaching_Subject) }}
          </p>
        </button>
      </div>
    </div>
    <div class="row">
      <div
        v-if="
          $route.path.includes('/grantsearch') ||
            $route.path.includes('/managegrants')
        "
        class="col-lg-4 col-12"
      >
        <button
          v-bind:id="'statesPopover' + grant.Grant_Id"
          class="btn text-left pt-0 pl-0"
          data-toggle="popover"
          data-trigger="focus"
          v-on:click="$focusElement('statesPopover' + grant.Grant_Id)"
          data-placement="right"
          v-bind:data-content="$createStatesDescriptionList(grant.State)"
        >
          <p class="mb-0 shorten-text">
            <b>States:</b> {{ $createStatesDescriptionList(grant.State) }}
          </p>
        </button>
      </div>
      <div class="col-lg-6 col-12">
        <button
          v-bind:id="'eligibilityPopover' + grant.Grant_Id"
          v-if="grant.Eligibility != 0"
          class="btn text-left pt-0 pl-0"
          data-toggle="popover"
          data-trigger="focus"
          v-on:click="$focusElement('eligibilityPopover' + grant.Grant_Id)"
          data-placement="right"
          data-html="true"
          v-bind:data-content="
            $createEligibilityDescriptionList(grant.Eligibility).cant
          "
        >
          <p class="mb-0">
            <b>Restrictions (funds may NOT be used for):</b>
            {{ $createEligibilityDescriptionList(grant.Eligibility).cant }}
          </p>
        </button>
        <p v-else class="mb-0 shorten-text">
          <b>Restrictions:</b>
          No Funding Restrictions
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  name: "GrantBody",
  props: {
    Grant: Object
  },
  data() {
    return {
      grant: this.Grant
    };
  },
  watch: {
    Grant: function() {
      this.grant = this.Grant;
    }
  },
  mounted() {
    $(document).ready(function() {
      $('[data-toggle="popover"]').popover();
    });
  },
  methods: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.shorten-text {
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>
